import { connect } from 'react-redux';
import { EWcLocation } from '../../../../types/filters';
import { IApplicationState, TTypedThunkDispatch } from '../../../../types/store';
import { changeWcLocationTypeFilter } from '../../../../store/filters/actions';
import { createExtraFilter, IExtraFilterProps } from '../helpers';
import { WC_LOCATIONS } from '../../../../constants/filters';

export const WcLocationLongNames: { [key: string]: string } = {
  indoors: 'Санузел в доме',
  outdoors: 'Санузел на улице',
};

const WcLocationTypeFilter = createExtraFilter<EWcLocation>(WC_LOCATIONS);

type TWcLocationTypeFilterProps = IExtraFilterProps<EWcLocation>;

export function mapStateToProps(state: IApplicationState) {
  const { wcLocationType } = state.filters;

  return { selected: wcLocationType ? [wcLocationType] : [] };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    toggle: (value: EWcLocation | undefined) => {
      dispatch(changeWcLocationTypeFilter(value));
    },
  };
}

export const WcLocationTypeFilterContainer = connect<
  Partial<TWcLocationTypeFilterProps>,
  Partial<TWcLocationTypeFilterProps>
>(
  mapStateToProps,
  mapDispatchToProps,
)(WcLocationTypeFilter);
